<template>
  <div style="background: var(--Grey-Base, #292929)">
    <div class="dashboard-container">
      <header class="dashboard-header">
        <div class="header-top">
          <!-- <button class="header-close-btn" @click="goToHome" aria-label="Close">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.2893 5.2893C5.67503 4.90357 6.30043 4.90357 6.68616 5.2893L12 10.6031L17.3138 5.2893C17.699 4.90357 18.325 4.90357 18.7107 5.2893C19.0964 5.67503 19.0964 6.30043 18.7107 6.68616L13.3969 12L18.7107 17.3138C19.0964 17.6995 19.0964 18.3255 18.7107 18.7112C18.325 19.0969 17.699 19.0969 17.3133 18.7112L12 13.3974L6.68616 18.7112C6.30043 19.0969 5.67443 19.0969 5.2887 18.7112C4.90297 18.3255 4.90297 17.6995 5.2887 17.3138L10.6025 12L5.2887 6.68616C4.90297 6.30043 4.90297 5.67443 5.2887 5.2887C5.67443 4.90297 6.30043 4.90297 6.68616 5.2887Z"
                fill="#F7F9FA"
              />
            </svg>
          </button> -->
          <div class="event-title">{{ scannerName }}</div>
        </div>
        <div class="event-meta">
          <span class="event-meta__item">
            <span class="meta-label">{{ localeStrings.indexStatsTotal }}</span>
            <span class="meta-value">{{ statistics.total }}</span>
          </span>
          <span class="event-meta__item">
            <span class="meta-label">{{
              localeStrings.indexStatsCheckedIn
            }}</span>
            <span class="meta-value checked">{{ statistics.checkedIn }}</span>
          </span>
          <span class="event-meta__item">
            <span class="meta-label">{{
              localeStrings.indexStatsPending
            }}</span>
            <span class="meta-value pending">{{ statistics.pending }}</span>
          </span>
        </div>
      </header>
    </div>
    <div class="tab-container">
      <nav class="product-tabs">
        <button
          v-for="product in products"
          :key="product.shopItemId || product.id"
          class="product-tab"
          :class="{ active: product.shopItemId === activeProductId }"
          @click="setActiveProduct(product.shopItemId)"
        >
          <span class="product-tab-text">{{ product.shopItemName }}</span>
        </button>
      </nav>
    </div>

    <div class="dashboard-container">
      <section class="filters">
        <label class="search-box">
          <span class="search-icon" aria-hidden="true">
            <img src="@/assets/Search.svg" alt="" />
          </span>
          <input
            v-model="searchQuery"
            type="text"
            class="search-input"
            :placeholder="localeStrings.indexSearchPlaceholder"
          />
        </label>

        <div class="status-filters">
          <button
            v-for="filter in localizedStatusFilters"
            :key="filter.value"
            class="status-pill"
            :class="{ active: statusFilter === filter.value }"
            @click="setStatusFilter(filter.value)"
          >
            {{ filter.label }}
          </button>
        </div>
      </section>

      <section class="attendee-table">
        <div class="table-scroll" ref="tableScroll" @scroll="handleScroll">
          <header class="table-header">
            <span class="header-cell name">{{
              localeStrings.indexTableHeaders.name
            }}</span>
            <span class="header-cell email">{{
              localeStrings.indexTableHeaders.email
            }}</span>
            <span class="header-cell check-in-time">{{
              localeStrings.indexTableHeaders.checkInTime
            }}</span>
            <span class="header-cell status sticky">{{
              localeStrings.indexTableHeaders.status
            }}</span>
          </header>
          <ul class="table-body">
            <li
              v-for="(item, index) in list"
              :key="item.id || item.attendeeId || index"
              class="table-row"
              @click="showItemDetail(item)"
            >
              <span class="cell name">{{ item.userName }}</span>
              <span class="cell email">{{ item.email }}</span>
              <span class="cell check-in-time">{{
                item.status === 1 ? formatDateTime(item.updateAt) : "--"
              }}</span>
              <span class="cell status sticky">
                <span class="status-chip" :class="getStatusClass(item.status)">
                  {{ getStatusLabel(item.status) }}
                </span>
              </span>
            </li>
            <li v-if="list.length === 0 && !isLoadingMore" class="table-empty">
              {{ localeStrings.indexEmpty }}
            </li>
            <li v-if="isLoadingMore" class="table-loading">
              <div class="loading-spinner"></div>
              <span>{{ localeStrings.indexLoading || "Loading..." }}</span>
            </li>
            <li v-if="!hasMore && list.length > 0" class="table-end">
              {{ localeStrings.indexNoMore || "No more data" }}
            </li>
          </ul>
        </div>
        <!-- 移除分页按钮，改用无限滚动 -->
        <!-- <div v-if="totalPages > 1" class="pagination">
          <button
            class="page-button"
            :disabled="currentPage === 1"
            @click="changePage(currentPage - 1)"
          >
            {{ localeStrings.indexPaginationPrev }}
          </button>
          <div class="page-status">
            {{ pageStatusText }}
          </div>
          <button
            class="page-button"
            :disabled="currentPage === totalPages"
            @click="changePage(currentPage + 1)"
          >
            {{ localeStrings.indexPaginationNext }}
          </button>
        </div> -->
      </section>
    </div>

    <footer class="dashboard-footer">
      <button class="scan-button" @click="goToScanner">
        {{ localeStrings.indexScanButton }}
      </button>
    </footer>

    <!-- 详情弹窗 -->
    <div
      class="detail-modal-overlay"
      v-if="showDetailModal"
      @click="closeDetailModal"
    >
      <div class="detail-modal" @click.stop>
        <div class="detail-modal-header">
          <h3 class="detail-modal-title">
            {{ localeStrings.indexDetailTitle }}
          </h3>
          <button class="detail-modal-close" @click="closeDetailModal">
            ×
          </button>
        </div>
        <div class="detail-modal-content" v-if="selectedItem">
          <div class="detail-item">
            <span class="detail-label">{{
              localeStrings.indexDetailName
            }}</span>
            <span class="detail-value">{{
              selectedItem.userName || "--"
            }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{
              localeStrings.indexDetailEmail
            }}</span>
            <span class="detail-value">{{ selectedItem.email || "--" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{
              localeStrings.indexDetailCheckInTime
            }}</span>
            <span class="detail-value">{{
              selectedItem.status === 1
                ? formatDateTime(selectedItem.updateAt)
                : "--"
            }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{
              localeStrings.indexDetailStatus
            }}</span>
            <span class="detail-value">
              <span
                class="detail-status-chip"
                :class="getStatusClass(selectedItem.status)"
              >
                {{ getStatusLabel(selectedItem.status) }}
              </span>
            </span>
          </div>
        </div>
        <div class="detail-modal-footer">
          <button class="detail-modal-close-btn" @click="closeDetailModal">
            {{ localeStrings.indexDetailClose }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import locales from "@/locales";
import {
  getScannerWebDetails,
  getStatistics,
  getList,
} from "@/api/orderQrcodeScanner";

export default {
  name: "IndexView",
  data() {
    return {
      language: "en",
      searchQuery: "",
      statusFilter: "all",
      currentPage: 1,
      pageSize: 8,
      totalItems: 0,
      statusFilters: [
        { labelKey: "all", value: null },
        { labelKey: "claimed", value: 1 },
        { labelKey: "unclaimed", value: 0 },
      ],
      statistics: {
        total: 0,
        checkedIn: 0,
        pending: 0,
      },
      products: [],
      activeProductId: "",
      list: [],
      id: "",
      token: "",
      watchLocked: false,
      scannerName: "",
      showDetailModal: false,
      selectedItem: null,
      isLoadingMore: false, // 是否正在加载更多
      scrollTimer: null, // 滚动防抖定时器
    };
  },
  computed: {
    localeStrings() {
      return locales[this.language] || locales.en;
    },
    localizedStatusFilters() {
      return this.statusFilters.map((filter) => ({
        ...filter,
        label:
          this.localeStrings.indexStatusFilters?.[filter.labelKey] ||
          filter.labelKey,
      }));
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.totalItems / this.pageSize));
    },
    pageStatusText() {
      return `${this.localeStrings.indexPaginationPage} ${this.currentPage} ${this.localeStrings.indexPaginationOf} ${this.totalPages}`;
    },
    hasMore() {
      // 判断是否还有更多数据
      // 如果列表长度已经达到或超过总数，说明没有更多数据了
      if (this.totalItems === 0) return false;
      return this.list.length < this.totalItems;
    },
  },
  watch: {
    searchQuery(newVal, oldVal) {
      if (newVal === oldVal || this.watchLocked || !this.activeProductId)
        return;
      this.currentPage = 1;
      this.list = []; // 清空列表
      this.fetchList(false); // 替换模式
    },
    statusFilter(newVal, oldVal) {
      if (newVal === oldVal || this.watchLocked || !this.activeProductId)
        return;
      this.currentPage = 1;
      this.list = []; // 清空列表
      this.fetchList(false); // 替换模式
    },
    "$route.query.lang"(newLang) {
      if (newLang) {
        this.setLanguage(newLang);
      }
    },
  },
  created() {
    this.initLanguage();
    // 如果路由中有 id，先保存到本地存储
    if (this.$route.query.id) {
      localStorage.setItem("scanner_id", this.$route.query.id);
    }
    // 从本地存储获取 id，如果本地存储没有则使用路由中的 id
    this.id = localStorage.getItem("scanner_id") || this.$route.query.id || "";
    this.token = this.$route.query.token;
    if (this.token) {
      localStorage.setItem("auth_token", this.token);
    }
  },
  mounted() {
    this.fetchProducts();
    this.scannerName = this.$route.query.scannerName;
  },
  methods: {
    initLanguage() {
      const langFromRoute = this.$route.query.lang;
      const storedLang = localStorage.getItem("lang");
      const nextLang = locales[langFromRoute]
        ? langFromRoute
        : locales[storedLang]
        ? storedLang
        : "en";
      this.setLanguage(nextLang);
    },
    setLanguage(lang) {
      this.language = locales[lang] ? lang : "en";
      localStorage.setItem("lang", this.language);
      if (this.activeProductId) {
        this.fetchStatistics();
        this.fetchList();
      }
    },
    async fetchProducts() {
      try {
        const result = await getScannerWebDetails({ id: this.id });
        this.products = result.data?.orderQrCodeScannerRelList || [];
        if (this.products.length > 0) {
          // 确保默认选中第一个产品
          const firstProductId =
            this.products[0].shopItemId || this.products[0].id;
          if (firstProductId) {
            // 如果当前没有选中任何产品，或者选中的不是第一个，则设置为第一个
            if (
              !this.activeProductId ||
              this.activeProductId !== firstProductId
            ) {
              await this.setActiveProduct(firstProductId);
            }
          }
        } else {
          this.activeProductId = "";
          this.statistics = { total: 0, checkedIn: 0, pending: 0 };
          this.list = [];
          this.totalItems = 0;
        }
      } catch (error) {
        console.error("获取关联商品失败:", error);
        this.products = [];
        this.activeProductId = "";
        this.statistics = { total: 0, checkedIn: 0, pending: 0 };
        this.list = [];
        this.totalItems = 0;
      }
    },
    async setActiveProduct(shopItemId) {
      if (!shopItemId || this.activeProductId === shopItemId) return;
      this.watchLocked = true;
      this.activeProductId = shopItemId;
      this.currentPage = 1;
      this.searchQuery = "";
      this.statusFilter = null;
      this.list = []; // 清空列表
      await this.fetchStatistics();
      await this.fetchList(false); // 替换模式
      this.watchLocked = false;
    },
    setStatusFilter(filter) {
      if (this.statusFilter === filter) return;
      this.statusFilter = filter;
      this.currentPage = 1; // 重置到第一页
      this.list = []; // 清空列表
    },
    getStatusClass(status) {
      return status === 1 || status === "1" ? "claimed" : "unclaimed";
    },
    getStatusLabel(status) {
      const isClaimed = status === 1 || status === "1";
      const key = isClaimed ? "claimed" : "unclaimed";
      return (
        this.localeStrings.indexStatusLabels?.[key] ||
        (isClaimed ? "Claimed" : "Unclaimed")
      );
    },
    localizedStatusText(status) {
      const key = status ? status.toLowerCase() : "";
      return this.localeStrings.indexStatusLabels?.[key] || status;
    },
    changePage(page) {
      const nextPage = Math.min(Math.max(page, 1), this.totalPages);
      if (nextPage !== this.currentPage) {
        this.currentPage = nextPage;
        this.fetchList(false); // 替换模式
      }
    },
    goToScanner() {
      this.$router.push({
        name: "Reader",
        query: { scannerName: this.scannerName, id: this.id },
      });
    },
    // 返回登录页（Home）
    goToHome() {
      // 通过浏览器返回上一页，一般为登录页
      this.$router.push({
        name: "Home",
        params: {
          name: this.$route.params.name,
          urlKey: this.$route.params.urlKey,
        },
      });
    },
    formatDateTime(timestamp) {
      if (!timestamp) {
        return "--";
      }
      const date = new Date(
        typeof timestamp === "number" ? timestamp : Number(timestamp)
      );
      if (Number.isNaN(date.getTime())) {
        return timestamp;
      }
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const hh = String(date.getHours()).padStart(2, "0");
      const mi = String(date.getMinutes()).padStart(2, "0");
      const ss = String(date.getSeconds()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
    },
    async fetchStatistics() {
      if (!this.activeProductId) return;
      try {
        const result = await getStatistics({
          shopItemId: this.activeProductId,
        });
        this.statistics.total = result.data?.qrcodeTotal || 0;
        this.statistics.checkedIn = result.data?.qrcodeVerified || 0;
        this.statistics.pending = result.data?.qrcodeNotVerified || 0;
      } catch (error) {
        console.error("获取统计数据失败:", error);
        this.statistics = { total: 0, checkedIn: 0, pending: 0 };
      }
    },
    async fetchList(append = false) {
      if (!this.activeProductId) return;
      // 如果正在加载更多，且是追加模式，则跳过
      if (append && this.isLoadingMore) return;
      // 如果没有更多数据，且是追加模式，则跳过
      if (append && !this.hasMore) return;

      try {
        if (append) {
          this.isLoadingMore = true;
        }

        const payload = {
          shopItemId: this.activeProductId,
          status: this.statusFilter,
          search: this.searchQuery,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
        };
        const keyword = this.searchQuery.trim();
        if (keyword) {
          payload.keyword = keyword;
        }
        if (this.statusFilter !== "all") {
          payload.status = this.statusFilter;
        }

        const result = await getList(payload);
        const data = result.items || result.data || [];

        // 从 result 对象获取总数，优先使用 result 中的总数
        const newTotalItems =
          result.total ||
          result.totalCount ||
          result.totalItems ||
          result.data?.total ||
          result.data?.totalCount ||
          result.data?.totalItems;

        if (append) {
          // 追加模式：将新数据追加到现有列表，并去重
          const existingIds = new Set(
            this.list
              .map((item) => item.id || item.attendeeId)
              .filter((id) => id !== undefined && id !== null && id !== "")
          );
          const newData = (data || []).filter((item) => {
            const id = item.id || item.attendeeId;
            // 如果没有 id，则不过滤（保留），避免丢数据
            if (!id) return true;
            return !existingIds.has(id);
          });
          this.list = [...this.list, ...newData];

          // 追加模式下，如果返回的数据为空，说明已经加载完所有数据
          if (data.length === 0 && this.list.length > 0) {
            // 将总数设置为当前列表长度，确保 hasMore 返回 false
            this.totalItems = this.list.length;
          }
          // 注意：追加模式下不更新 totalItems，保持第一次加载时的总数
        } else {
          // 替换模式：替换整个列表（搜索、筛选、切换产品时）
          this.list = data || [];
          // 替换模式时，使用服务器返回的总数，如果没有则使用列表长度
          this.totalItems =
            newTotalItems !== undefined && newTotalItems !== null
              ? newTotalItems
              : this.list.length;
        }
      } catch (error) {
        console.error("获取列表失败:", error);
        if (!append) {
          this.list = [];
          this.totalItems = 0;
        }
      } finally {
        if (append) {
          this.isLoadingMore = false;
        }
      }
    },
    // 处理滚动事件（添加防抖）
    handleScroll(event) {
      // 清除之前的定时器
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }

      // 设置防抖，200ms 后执行
      this.scrollTimer = setTimeout(() => {
        const scrollElement = event.target;
        const scrollTop = scrollElement.scrollTop;
        const scrollHeight = scrollElement.scrollHeight;
        const clientHeight = scrollElement.clientHeight;

        // 当滚动到距离底部 100px 时，开始加载下一页
        if (scrollHeight - scrollTop - clientHeight < 100) {
          this.loadMore();
        }
      }, 200);
    },
    // 加载更多数据
    loadMore() {
      // 防止重复加载
      if (this.isLoadingMore || !this.hasMore) return;

      // 如果还有更多页，加载下一页
      if (this.currentPage < this.totalPages) {
        this.currentPage += 1;
        this.fetchList(true); // 追加模式
      }
    },
    showItemDetail(item) {
      this.selectedItem = item;
      this.showDetailModal = true;
    },
    closeDetailModal() {
      this.showDetailModal = false;
      this.selectedItem = null;
    },
  },
};
</script>

<style lang="less" scoped>
.dashboard-container {
  background: var(--Grey-Darker, #191919);
  // min-height: 100vh;
  padding: 0 12px; /* 增加底部 padding，避免内容被固定按钮遮挡 */
  display: flex;
  flex-direction: column;
  gap: 24px;
  color: #ffffff;
  box-sizing: border-box;
}

.dashboard-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.header-top {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-close-btn {
  margin-top: 16px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: background-color 0.3s ease;
  flex-shrink: 0;
  line-height: 1;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-close-btn svg {
  width: 20px;
  height: 20px;
}

.header-close-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.tab-container {
  background: var(--Grey-Darkest, #090a0a);
  padding-top: 16px;
}
.event-title {
  margin-top: 16px;
  text-align: left;
  overflow: hidden;
  color: var(--White-Lightest, #f7f9fa);
  text-overflow: ellipsis;
  /* 加粗 21 */
  font-family: var(--app-font-family);
  font-size: 21px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px; /* 142.857% */
  letter-spacing: 1.05px;
  overflow: hidden;
  white-space: nowrap;
  min-width: 0;
}

.event-meta {
  padding: 16px 0;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 16px;
}

.event-meta__item {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  min-width: 0;
  position: relative;

  &:not(:last-child)::after {
    content: "";
    position: absolute;
    right: -6px;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 60%;
    background-color: rgba(255, 255, 255, 0.1);
  }
}

.meta-label {
  color: var(--Grey-Lighter, #6c6c72);
  text-align: center;

  /* 普通 14 */
  font-family: var(--app-font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
}

.meta-value {
  color: var(--White-Lightest, #f7f9fa);
  text-align: center;

  /* 加粗 19 */
  font-family: var(--app-font-family);
  font-size: 19px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.meta-value.checked {
  color: var(--Primary-Pink-500, #f68fa6);
}

.meta-value.pending {
  color: var(--White-Lightest, #f7f9fa);
}

.product-tabs {
  display: flex;
  flex-wrap: nowrap;
  padding-left: 12px;
  padding-right: 12px;
  overflow-x: auto;
  scrollbar-width: none; /* Firefox */
}

.product-tabs::-webkit-scrollbar {
  display: none;
}

.product-tab {
  flex: 0 0 calc(50% - 10px);
  border: none;
  border-radius: 14px;
  background: transparent;
  color: rgba(255, 255, 255, 0.65);
  padding: 12px 10px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.15s ease;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;
}

.product-tab-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
}

.product-tab.active {
  display: flex;
  padding: 8px 16px var(--SM, 8px) 16px;
  justify-content: center;
  align-items: center;
  gap: var(--XS, 4px);
  border-radius: 16px 16px 0 0;
  background: var(--Grey-Darker, #191919);
}

.filters {
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.search-box {
  display: flex;
  height: 36px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: var(--LG, 24px);
  background: var(--white-transparent-8, rgba(247, 249, 250, 0.08));
  backdrop-filter: blur(calc(16px / 2));
}

.search-icon {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;

  svg {
    width: 18px;
    height: 18px;
    fill: currentColor;
  }
}

.search-input {
  flex: 1;
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 14px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }

  &:focus {
    outline: none;
  }
}

.status-filters {
  display: flex;
  gap: 8px;
}

.status-pill {
  display: flex;
  padding: var(--SM, 8px) var(--MD, 16px);
  justify-content: center;
  align-items: center;
  color: var(--White-Lightest, #f7f9fa);

  /* 中文繁體/普通 12 */
  font-family: var(--app-font-family);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: var(--LG, 24px);
  background: var(--Grey-Base, #292929);
  border: none;
  // border-radius: 20px;
  // padding: 10px 18px;
  // font-size: 13px;
  // background-color: #1b1b1b;
  // color: rgba(255, 255, 255, 0.75);
  // cursor: pointer;
  // transition: all 0.15s ease;
}

.status-pill.active {
  color: var(--Grey-Dark, #1f1f1f);
  background: var(--White-Lighter, #f2f4f5);
  border: none;
}

.attendee-table {
  flex: 1;
  border-radius: 16px;
  border: 1px solid var(--Grey-Base, #292929);
  background: var(--Grey-Dark, #1f1f1f);
  box-shadow: -8px 0 8px 0 rgba(0, 0, 0, 0.16);
  background-color: #111111;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 550px;
  max-height: calc(100vh - 300px);
}

.table-scroll {
  position: relative;
  overflow-x: auto;
  overflow-y: auto;
  flex: 1;
  max-height: calc(100vh - 400px);
  min-height: 400px;
  z-index: 5; /* 提高容器层级，确保其内部的滚动条在分页组件之上 */
}

.table-scroll::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  display: block;
}

.table-scroll::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 999px;
}

.table-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.table-header {
  display: grid;
  grid-template-columns: 120px 170px 170px 119px;
  min-width: 560px;
  padding: 12px 16px;
  position: relative;
  z-index: 1;
  // color: rgba(255, 255, 255, 0.5);
  background-color: #1f1f1f;
  color: var(--White-Dark, #979c9e);
  gap: 8px;

  /* En/Reg/14 */
  font-family: var(--app-latin-font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: 0.42px;
}

.header-cell {
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  min-width: 0;
  max-width: 100%;
  text-align: left;
  line-height: 18px;
}

.header-cell.status {
  text-align: center;
}

.table-header::after {
  content: "";
  position: absolute;
  top: 0;
  right: -30px;
  bottom: 0;
  width: 30px;
  background-color: #1f1f1f;
}

.table-body {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.table-row {
  display: grid;
  grid-template-columns: 120px 170px 170px 119px;
  min-width: 590px;
  padding: 12px 16px;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  cursor: pointer;
  transition: background-color 0.2s ease;
  gap: 8px;
}

.table-row:hover {
  background-color: #181818;
}

.table-row:hover .sticky {
  background-color: #181818;
}

.table-row:last-child {
  border-bottom: none;
}

.cell {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  min-width: 0;
  max-width: 100%;
  text-align: left;
  line-height: 1.5;
}

.cell.email {
  color: rgba(255, 255, 255, 0.7);
}

.cell.check-in-time {
  color: rgba(255, 255, 255, 0.7);
}

.status {
  display: block;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

.sticky {
  position: sticky;
  right: 0;
  z-index: 1;
}

.table-header .sticky {
  background-color: #1f1f1f;
  z-index: 3;
  padding-left: 16px;
  margin-left: -8px;
}

.table-header .sticky::after {
  content: "";
  position: absolute;
  top: -12px;
  right: -24px;
  bottom: -12px;
  width: 40px;
  background-color: #1f1f1f;
}

.table-row .sticky {
  background-color: #111111;
  padding-left: 16px;
  justify-content: flex-start;
}

.status-chip {
  min-width: 60px;
  height: 34px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.3px;
  padding: 0 16px;
}

.status-chip.claimed {
  background: rgba(18, 92, 55, 0.9);
  color: #4ff4b2;
}

.status-chip.unclaimed {
  background: rgba(70, 70, 70, 0.9);
  color: rgba(255, 255, 255, 0.8);
}

.table-empty {
  padding: 32px 20px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
}

.table-loading {
  padding: 32px 20px;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.loading-spinner {
  width: 24px;
  height: 24px;
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-top-color: rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.table-end {
  padding: 24px 20px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
}

.pagination {
  margin-top: 16px;
  padding: 16px 20px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-shrink: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  background-color: #111111;
}

.page-button {
  min-width: 72px;
  height: 40px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.15s ease, transform 0.15s ease,
    opacity 0.15s ease;
}

.page-button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(-1px);
}

.page-button:active:not(:disabled) {
  transform: translateY(0);
}

.page-button:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.page-status {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  z-index: 2; /* 降低分页组件层级，防止遮挡表格底部的横向滚动条 */
}

.dashboard-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  padding: 24px 16px;
  background: linear-gradient(
    180deg,
    rgba(19, 19, 19, 0) 0%,
    rgba(19, 19, 19, 0.95) 20%,
    #131313 100%
  );
  backdrop-filter: blur(10px);
  z-index: 100;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.3);
}

.scan-button {
  width: 100%;
  padding: 16px;
  border-radius: 18px;
  border: none;
  background: #f68fa6;
  color: #171717;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.2px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.scan-button:hover {
  transform: translateY(-2px);
}

.scan-button:active {
  transform: translateY(0);
  box-shadow: none;
}

@media screen and (min-width: 768px) {
  .dashboard-container {
    max-width: 640px;
    margin: 0 auto;
  }

  .tab-container {
    max-width: 640px;
    margin: 0 auto;
  }

  .dashboard-footer {
    padding-left: max(20px, calc((100% - 640px) / 2));
    padding-right: max(20px, calc((100% - 640px) / 2));
  }

  .filters {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .search-box {
    flex: 1;
  }
}

// 详情弹窗样式
.detail-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.detail-modal {
  width: 90%;
  max-width: 400px;
  background: #1e1e1e;
  border-radius: 16px;
  overflow: hidden;
  animation: slideUp 0.3s ease;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.detail-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.detail-modal-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
}

.detail-modal-close {
  background: none;
  border: none;
  color: #ffffff;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.detail-modal-close:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.detail-modal-content {
  padding: 24px;
  text-align: left;
}

.detail-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  text-align: left;

  &:last-child {
    margin-bottom: 0;
  }
}

.detail-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 8px;
  font-weight: 500;
  text-align: left;
}

.detail-value {
  font-size: 15px;
  color: #ffffff;
  word-break: break-word;
  text-align: left;
}

.detail-status-chip {
  display: flex;
  height: 28px;
  width: 87px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: var(--LG, 24px);
}

.detail-status-chip.claimed {
  color: var(--Green-Base, #23c16b);
  background: var(--green-8, rgba(35, 193, 107, 0.08));
  /* Background Blur 16% */
  backdrop-filter: blur(calc(var(--MD, 16px) / 2));
}

.detail-status-chip.unclaimed {
  background: rgba(70, 70, 70, 0.9);
  color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(calc(var(--MD, 16px) / 2));
}

.detail-modal-footer {
  padding: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: center;
}

.detail-modal-close-btn {
  width: 100%;
  padding: 16px;
  background-color: transparent;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.detail-modal-close-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.5);
}

.detail-modal-close-btn:active {
  transform: scale(0.98);
}

// 移动端适配
@media screen and (max-width: 768px) {
  .detail-modal {
    width: 95%;
    max-width: none;
    border-radius: 16px 16px 0 0;
    margin-top: auto;
    margin-bottom: 60%;
  }

  .detail-modal-header {
    padding: 16px 20px;
  }

  .detail-modal-title {
    font-size: 18px;
  }

  .detail-modal-content {
    padding: 20px;
  }

  .detail-item {
    margin-bottom: 16px;
  }

  .detail-label {
    color: var(--Grey-Lighter, #6c6c72);

    /* En/Reg/14 */
    font-family: var(--app-latin-font-family);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 128.571% */
    letter-spacing: 0.42px;
  }

  .detail-value {
    color: var(--White-Lightest, #f7f9fa);

    /* En/Reg/16 */
    font-family: var(--app-latin-font-family);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 112.5% */
    letter-spacing: 0.48px;
  }

  .detail-modal-footer {
    padding: 16px;
  }

  .detail-modal-close-btn {
    font-size: 14px;
  }
}
</style>
